import { Dropzone } from '../../components/uploader'; 
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { Head } from '@inertiajs/react';

export default function Index() {
  return (
    <>
      <Head title="Rooster Vision - Rooster lookup" />
      <Navbar />
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full px-4 ml-auto mr-auto text-center">
              <div>
                <h1 className="text-black font-semibold text-5xl mb-10">Look up a rooster</h1>
                <div className="w-full px-4 mb-10">
                  <div className="container font-bold text-4xl text-blue-500">
                    <Dropzone name="image" multiple={false} required={true} uploadType="lookup" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
